// NPM
import React, { Component } from 'react';

// Components
import logo from 'assets/logo.png';
import ResultsLink from './ResultsLink';
import SharedResultsLink from './SharedResultsLink';

// External Components
import { NavLink } from 'react-router-dom';

class HeaderNavigation extends Component {
  render() {
    return (
      <React.Fragment>
        <NavLink className="Header-logo" to="/">
          <img alt="Delphia" src={logo} />
        </NavLink>
        <div className="Header-navigation-list">
          <NavLink exact className="Header-navigation-item" to="/">
            Home
          </NavLink>
          <NavLink exact className="Header-navigation-item" to="/survey">
            Survey
          </NavLink>
          <ResultsLink />
          <SharedResultsLink />
        </div>
      </React.Fragment>
    );
  }
}

export default HeaderNavigation;



// WEBPACK FOOTER //
// ./src/Components/Layout/HeaderNavigation.js